import { render, staticRenderFns } from "./meta_data.vue?vue&type=template&id=786f66f3&"
import script from "./meta_data.vue?vue&type=script&lang=js&"
export * from "./meta_data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786f66f3')) {
      api.createRecord('786f66f3', component.options)
    } else {
      api.reload('786f66f3', component.options)
    }
    module.hot.accept("./meta_data.vue?vue&type=template&id=786f66f3&", function () {
      api.rerender('786f66f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/platforms_portal/orders/tabs/meta_data.vue"
export default component.exports